import { Currency } from 'constants/currencies'
import { FilterArtworkHitProps } from 'types'
import { pickPrice } from 'utils/currencies'

export const getArtworksQueryUrl = (query?: string) =>
  query
    ? `/artworks?${encodeURIComponent(
        `${process.env.NEXT_PUBLIC_STAGE}_filter[query]`
      )}=${encodeURIComponent(query)}`
    : '#'

export const getIndexName = (name: 'filter' | 'search') => {
  return (process.env.NEXT_PUBLIC_STAGE || 'production') + '_' + name
}

export function pickHitPrices(
  hit: FilterArtworkHitProps,
  userCurrency: Currency
) {
  return {
    highestBid: pickPrice({
      userCurrency,
      price: hit.highestBid,
      priceCurrency: hit.highestBidCurrency,
      priceGbp: hit.highestBidPriceConvertedToGbp,
      priceUsd: hit.highestBidPriceConvertedToUsd,
    }),
    lowestAsk: pickPrice({
      userCurrency,
      price: hit.lowestAsk,
      priceCurrency: hit.lowestAskCurrency,
      priceGbp: hit.lowestAskPriceConvertedToGbp,
      priceUsd: hit.lowestAskPriceConvertedToUsd,
    }),
  }
}
